<template>
  <div class="container-fluid preview">
    <header>
      <base target="_blank"/>
    </header>
    <div class="row">
      <div class="col">
        <br>
        <h4>{{this.listName}}</h4>
        <br>
        <h3 class="text-left">Categories: </h3>
        <div v-for="category in categoryList" v-bind:key="category">
          <div class="text-left">
            <h5 class="mb-1">{{category}}</h5>
          </div>
        </div>
        <br>
        <!-- <div v-for="result in resultList" v-bind:key="result.guid">
          <div class="card">
            <div class="card-body text-left">
              <h5 style="text-decoration:underline" class="mb-1">Category: {{result.category}}</h5>
              <h5 class="mb-1">{{result.title}}</h5>
              <small>{{result.pubDate}}</small>
              <p class="mb-1" v-html="result.comments"></p>
              <a :href="result.link"> Read More </a>
            </div>
          </div>
        </div> -->
        <div v-for="category in categoriesAndArticles" v-bind:key="category">
          <!-- <div v-for="cat in categoryList" v-bind:key="cat"> -->
            <br>
            <div class="text-left">
          <h3 style="text-decoration:underline" class="mb-1">Category: {{category[0].category}}</h3>
            </div>
          <br>
          <div v-for="result in category" v-bind:key="result.guid">
            <div class="card">
            <div class="card-body text-left">
              <h5 class="mb-1">{{result.title}}</h5>
              <small>{{result.pubDate.slice(0,17)}}</small>
              <p class="mb-1" v-html="result.comments"></p>
              <a :href="result.link"> Read More </a>
            </div>
          <!-- </div> -->
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleService from '@/ArticleService'

export default {
  name: 'DynamicList',
  data: function () {
    return {
      listName: '',
      resultList: [],
      categoryList: [],
      finalList: [],
      versionName: '',
      categoriesAndArticles: {}
    }
  },
  async created () {
    this.listName = this.$route.params.list
    this.resultList = await ArticleService.getbyList(this.listName)
    this.resultList.forEach(element => {
      // console.log(element.category)
      if (!this.categoryList.includes(element.category)) {
        this.categoryList.push(element.category)
      }
    })
    this.categoryList.sort(function (a, b) {
      if (a !== null && b !== null) {
        if (a.toUpperCase() > b.toUpperCase()) { return 1 }
        if (a.toUpperCase() < b.toUpperCase()) { return -1 }
        return 0
      }
    })
    console.log(this.categoryList)
    this.categoryList.forEach(category => {
      this.resultList.forEach(article => {
        if (article.category === category) {
          this.finalList.push(article)
        }
      })
    })
    this.categoryList.forEach(category => {
      console.log(category)
      this.categoriesAndArticles[category] = []
      this.resultList.forEach(article => {
        if (article.category === category) {
          this.categoriesAndArticles[category].push(article)
        }
      })
    })
    console.log(this.finalList)
    console.log(this.categoriesAndArticles)
  }
}
</script>

<style scoped>

</style>
